export function stripMarkdown(markdown: string): string {
	let text = markdown;

	// Remove code blocks (triple backticks)
	text = text.replace(/```[\s\S]*?```/g, "");

	// Remove inline code (single backticks)
	text = text.replace(/`([^`]+)`/g, "$1");

	// Remove images ![alt](url)
	text = text.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");

	// Remove links [text](url) - keep the text
	text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

	// Remove reference-style links [text][ref]
	text = text.replace(/\[([^\]]+)\]\[[^\]]*\]/g, "$1");

	// Remove bold/italic (**, *, __, _)
	text = text.replace(/\*\*([^*]+)\*\*/g, "$1");
	text = text.replace(/\*([^*]+)\*/g, "$1");
	text = text.replace(/__([^_]+)__/g, "$1");
	text = text.replace(/_([^_]+)_/g, "$1");

	// Remove strikethrough ~~text~~
	text = text.replace(/~~([^~]+)~~/g, "$1");

	// Remove headers (# ## ### etc.)
	text = text.replace(/^#{1,6}\s+/gm, "");

	// Remove horizontal rules (---, ***, ___)
	text = text.replace(/^[-*_]{3,}$/gm, "");

	// Remove blockquotes (> )
	text = text.replace(/^>\s*/gm, "");

	// Remove list markers (-, *, +, 1. etc.)
	text = text.replace(/^[\s]*[-*+]\s+/gm, "");
	text = text.replace(/^[\s]*\d+\.\s+/gm, "");

	// Remove table formatting (| and alignment markers)
	text = text.replace(/\|/g, " ");
	text = text.replace(/^[\s]*:?-+:?[\s]*$/gm, "");

	// Clean up extra whitespace
	text = text.replace(/\n{3,}/g, "\n\n");
	text = text.replace(/[ \t]+/g, " ");
	text = text.trim();

	return text;
}
